module.exports = __webpack_public_path__ + "img/23_92.95c0ff44.png";